import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import VideoPlayer from '@medscape-promo/medscapetv/main/player';
import Breadcrumb from '@medscape-promo/medscapetv/main/breadcrumb';
import PersistentVideoBar from '@medscape-promo/medscapetv/main/persistent-video-bar';
import HtmlContent from '@medscape-promo/medscapetv/html-content';
import IfiContent from './ifi-content';

class IfiTemplate extends Component {
    constructor(props) {
        super(props);
        require('./ifi-template.scss');
        //console.log("[IfiTemplate] props:",props);
    }

    handleModalClose(e) {
        this.props.onModalClose();
    }

    render() {
        const { type, location, imageServer, breadcrumb, title, video, templateContent, trackingPixels, linksTarget } = this.props;
        if (type === "modal") {
            return (
                <section className="template-container ifi-template ifi-modal-template">
                    <Breadcrumb {...breadcrumb} />    
                    <div className="video-placeholder"></div>
                    <Modal key="ifi-modal" className="mtv-ifi-modal" open={true} onClose={this.handleModalClose.bind(this)}>
                        <div className="modal-container">
                            <div className="top-row-container">
                                <div className="logo"><img src={`${imageServer.host}/pi/logos/mscp-logo.png`} /></div>
                                <CloseButton onClick={this.handleModalClose.bind(this)} />
                            </div>
                            <VideoPlayer key="mtv-video-player" config={video} tracking-pixels={trackingPixels}/>
                            <IfiContent templateContent={templateContent} title={title} />
                        </div>
                    </Modal>
                </section>
            )
        } else {
            return (
                <section className="template-container ifi-template">
                    <Breadcrumb {...breadcrumb} />
                    <PersistentVideoBar className="ifi" key="persistent-video-bar" location={location} >                        
                        <div className="video-section">
                            <VideoPlayer key="mtv-video-player" config={video} tracking-pixels={trackingPixels}/>
                        </div>
                        <div className="details-section">
                            <div className="episode-label"><span>Information from Industry</span></div>
                            <div className="episode-title" dangerouslySetInnerHTML={{__html: title} }></div>
                            <HtmlContent className="content" content={templateContent} linksTarget={linksTarget} />
                        </div>
                    </PersistentVideoBar>
                    <IfiContent templateContent={templateContent} title={title} />
                </section>

            )
        }
    }
    static get propTypes() {
        return {
            templateContent: PropTypes.string,
            trackingPixels: PropTypes.object,
            type: PropTypes.string,
            location: PropTypes.object,
            imageServer: PropTypes.object,
            breadcrumb: PropTypes.object,
            title: PropTypes.string,
            video: PropTypes.object,
            linksTarget: PropTypes.string,
            onModalClose: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            templateContent: "",
            trackingPixels: null,
            type: "page",
            location: document.location,
            imageServer: { host: "" },
            breadcrumb: {},
            title: "",
            video: {},
            linksTarget: "",
            onModalClose: () => {}
        }
    }
}


function CloseButton(props) {
    return (
        <button className="close-button" onClick={ props.onClick }>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enableBackground="new 0 0 1000 1000" xmlSpace="preserve">
                <g><path d="M22.3,81.9C6.1,65.8,6,39,22.5,22.5C39.1,5.9,65.6,5.9,81.9,22.3L500,440.3L918.1,22.3c16.1-16.1,43-16.3,59.5,0.2c16.6,16.6,16.6,43.1,0.2,59.5L559.7,500l418.1,418.1c16.1,16.1,16.3,43-0.2,59.5c-16.6,16.6-43.1,16.6-59.5,0.2L500,559.7L81.9,977.7c-16.1,16.1-43,16.3-59.5-0.2c-16.6-16.6-16.6-43.1-0.2-59.5L440.3,500L22.3,81.9z"/></g>
            </svg>
        </button>
    )
}
CloseButton.propTypes = {
    onClick: PropTypes.func.isRequired
}

export default IfiTemplate;